import { TextArea } from "@blueprintjs/core";
import { DailyInstantECharts } from "../charts/daily-instant";
import { useEffect, useState } from "react";
import { DailySentimentECharts } from "../charts/daily-sentiment-mom";
import { PageHider } from "../components/PageHider";
import { HourlySentimentMomentumECharts } from "../charts/hourly-sentiment-mom";
import { Osilator } from "../charts/osilator";
import { WeeklyPage } from "../components/WeeklyPage";
import { ImageContainer } from "../components/ImageContainer";
import { WeeklyHeader } from "../components/WeeklyHeader";

export const Page6 = ({
  onPageDataUpdated,
  weekData,
  pageIndex,
  subIndex,
  registerPageIndex,
}: any) => {
  const [comments, setComments] = useState<any>(weekData?.page6?.comment ?? "");
  const [focusedImageId, setFocusedImageId] = useState<number>(1);

  const onTitleUpdated = (text: string) => {
    setComments(text);
    onPageDataUpdated("page6", "comment", text);
  };
  useEffect(() => {
    registerPageIndex(pageIndex, subIndex, "Saatlik Sentiment");
  }, []);

  return (
    <WeeklyPage
      pageId={`page-${pageIndex}-${subIndex}`}
      onClick={() => {
        setFocusedImageId((prev) => prev + 1);
      }}
    >
      <WeeklyHeader title="SAATLİK SENTİMENT MOMENTUM" />
      <div style={{ display: "flex", gap: 10 }}>
        <div
          style={{ width: "25%", paddingLeft: "14px", paddingRight: "24px" }}
        >
          <div
            style={{
              backgroundColor: "#F7AF3D",
              padding: "5px 10px",
              fontWeight: "600",
              marginBottom: "10px",
              borderRadius: "2px",
              fontSize: "20px",
            }}
          >
            Saatlik Sentiment Momentum Yorumu
          </div>
          <TextArea
            className="no-print"
            style={{ flex: 1, width: "100%", height: "90%" }}
            placeholder="Saatlik Sentiment Değerlendirmesini girebilirisiniz"
            onChange={(e) => onTitleUpdated(e.target.value)}
            defaultValue={comments}
          />
          <div
            className="print-only-block"
            style={{ color: "black", fontSize: 16, lineHeight: "24px" }}
          >
            <p>
              {comments
                ?.split("\n")
                .filter((item: string) => item.trim() !== "")
                .map((item: string) => (
                  <p>{item}</p>
                ))}
            </p>
          </div>
        </div>
        <div
          style={{
            backgroundColor: "rgb(19,23,35)",
            flex: 1,
            marginRight: 14,
            width: "75%",
            borderRadius: 5,
            overflow: "hidden",
          }}
        >
          <HourlySentimentMomentumECharts />
        </div>
        <ImageContainer
          pageId={"page6"}
          onPageDataUpdated={onPageDataUpdated}
          weekData={weekData?.page6}
          focusedImageId={focusedImageId}
        />
      </div>
    </WeeklyPage>
  );
};
